import React, { useRef, useEffect, useState } from "react";
import { FieldError, useForm, UseFormRegister } from "react-hook-form";

interface TextInputFieldProps {
  type: string; // Specify types like 'text' | 'date' | etc. if known
  placeholder?: string;
  name: string;
  register: UseFormRegister<any>; // Use appropriate type for your form
  error?: FieldError; // Type for error from react-hook-form
  className?: string;
  id?: string;
  errMsgClassName?: string;
  disabled?: boolean;
  readOnly?: boolean;
  onChange?: (value: string) => void;
  onInputs?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  maxLength?: number;
  style?: React.CSSProperties; // Adjust according to your needs
  onBlur?: (value: string) => void;
  size: string;
}
const TextInputField: React.FC<TextInputFieldProps> = ({
  type,
  placeholder,
  name,
  register,
  error,
  className,
  id,
  errMsgClassName,
  disabled,
  readOnly,
  onChange,
  onInputs,
  maxLength,
  style,
  onBlur,
  size
}) => {
  const registerData = register(name);
  const path = window.location.pathname;
  const { setValue } = useForm();
  const handleInput = (event: any) => {
    const value = event.target.value.replace(/[^0-9]/g, "");
    setValue(name, value);
  };

  const handleKeyDown = (event: any) => {
    // Check if the Enter key (keyCode 13) is pressed
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent default action
    }
  };

  return (
    <div className={`form-group ${size}`}>
      <input
        id={id}
        type={type}
        placeholder={placeholder}
        name={registerData.name}
        ref={registerData.ref}
        maxLength={maxLength}
        onChange={(e) => {
          if (onChange) {
            onChange(e.target.value);
          }
          if (onInputs) {
            handleInput(e);
          }
          registerData.onChange(e);
        }}
        onKeyDown={handleKeyDown}
        className={`${error ? " has-error" : ""
          }  ${className ? className :"form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"}

          ${readOnly ? "bg-gray-200" : ""}  `}
        disabled={disabled}
        readOnly={readOnly}
        onInput={onInputs ? handleInput : undefined}
        onBlur={(e) => {
          if (onBlur) {
            onBlur(e.target.value);
          }
          registerData.onBlur(e);
        }}
      />
      <div>
        {error && (
          <span
            className={
              errMsgClassName
                ? errMsgClassName
                : "text-red-500   font-sm  text-[12px] "
            }
          >
            {error.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default TextInputField;
